// extracted by mini-css-extract-plugin
export default {"select":"style_select__Y8kyo","button":"style_button__yLabP"};